import Crypto from 'crypto'

export const encryptData = (data, keyCode) => {
  if (!data) return ''

  const bytesToBeEncrypted = Buffer.from(data, 'utf8')
  let passwordBytes = Buffer.from(keyCode, 'utf8')

  passwordBytes = Crypto.createHash('sha256').update(passwordBytes).digest()
  const encrypted = aes_encrypt(bytesToBeEncrypted, passwordBytes)
  return encrypted
}

export const decryptData = (data, keyCode) => {
  if (!data) return ''

  const bytesToBeDecrypted = Buffer.from(data, 'base64')
  let passwordBytes = Buffer.from(keyCode, 'utf8')

  passwordBytes = Crypto.createHash('sha256').update(passwordBytes).digest()
  const decrypted = aes_decrypt(bytesToBeDecrypted, passwordBytes)
  return decrypted
}

const aes_decrypt = (bytesToBeDecrypted, passwordBytes) => {
  const keyLen = 32
  const ivLen = 16
  const salt = [
    22 & 0xff,
    76 & 0xff,
    43 & 0xff,
    120 & 0xff,
    78 & 0xff,
    6 & 0xff,
    24 & 0xff,
    72 & 0xff,
    15 & 0xff,
    16 & 0xff,
    44 & 0xff,
    80 & 0xff,
    26 & 0xff,
    10 & 0xff,
    15 & 0xff,
    112 & 0xff,
    2 & 0xff,
    94 & 0xff,
    11 & 0xff,
    127 & 0xff,
    119 & 0xff,
    35 & 0xff,
    18 & 0xff,
    121 & 0xff,
  ]
  const saltBuffer = Buffer.from(salt)
  const key = Crypto.pbkdf2Sync(passwordBytes, saltBuffer, 1000, keyLen + ivLen, 'sha1')
  const decipher = Crypto.createDecipheriv(
    'aes-256-cbc',
    Buffer.from(key.slice(0, keyLen)),
    Buffer.from(key.slice(keyLen, keyLen + ivLen)),
  )

  let decrypted = decipher.update(bytesToBeDecrypted)
  decrypted = Buffer.concat([decrypted, decipher.final()])
  return decrypted.toString()
}

const aes_encrypt = (bytesToBeDecrypted, passwordBytes) => {
  const keyLen = 32
  const ivLen = 16
  const salt = [
    22 & 0xff,
    76 & 0xff,
    43 & 0xff,
    120 & 0xff,
    78 & 0xff,
    6 & 0xff,
    24 & 0xff,
    72 & 0xff,
    15 & 0xff,
    16 & 0xff,
    44 & 0xff,
    80 & 0xff,
    26 & 0xff,
    10 & 0xff,
    15 & 0xff,
    112 & 0xff,
    2 & 0xff,
    94 & 0xff,
    11 & 0xff,
    127 & 0xff,
    119 & 0xff,
    35 & 0xff,
    18 & 0xff,
    121 & 0xff,
  ]
  const saltBuffer = Buffer.from(salt)
  const key = Crypto.pbkdf2Sync(passwordBytes, saltBuffer, 1000, keyLen + ivLen, 'sha1')
  const cipher = Crypto.createCipheriv(
    'aes-256-cbc',
    Buffer.from(key.slice(0, keyLen)),
    Buffer.from(key.slice(keyLen, keyLen + ivLen)),
  )
  let encrypted = cipher.update(bytesToBeDecrypted)
  encrypted = Buffer.concat([encrypted, cipher.final()])
  return encrypted.toString('base64')
}
